import _ from 'lodash'
import React from 'react'
import {NullAsDefault} from 'views/Shared'
import {CategoryFilterGroup} from '../Category'
import {paths} from "../../MainPage/contains";
import categoryIcons from "../../../conts/categoryIcons";
import {Link} from "react-router-dom";
import {getId} from 'apis/model/base'

const SelectCategoryGroup = ({groups, name, renderAction = NullAsDefault}) => {
    const items = _.get(groups, name, [])
    return (
        <div className="w-full flex flex-col">
            <CategoryFilterGroup
                title={name}
                categories={items}
                renderCategory={(item, index) => {
                    const {name, avatar, language, alt_idname} = item
                    const id = getId(item)
                    const pathname = paths.categoryPath
                        .replace(':category', id)

                    const Icon = _.get(categoryIcons, item.idname, categoryIcons["default"])

                    return (
                        <div
                            key={index}
                            className="flex items-center w-full">
                            <Link
                                to={{
                                    pathname,
                                    search: ``,
                                    state: {refId: alt_idname},
                                }}
                                className="flex items-center gap-2 flex-1 text-color-000 no-underline">
                                <Icon size={20}/>
                                <span className="font-medium">{name}</span>
                            </Link>
                            {renderAction(item)}
                        </div>
                    )
                }}
            />
        </div>
    )
}

export default SelectCategoryGroup
